import React, { useState, useEffect } from "react";
import { withTitle } from "../../HoC";

import style from "./register.module.scss";
import { TextInput } from "../../Components/Input";
import { Button } from "../../Components/button";
import { getRequest, postRequest } from "../../services/Requests";
import { Confirmation } from "../../Components/Confirmed/Confirmation";
import { validateEmail } from "../../utils/validations";
import { priorities as allPriorities } from "../../utils/constants";
import { translate } from "../../translations/translate";

export const Register = (props) => {

  const { deviceId } = props.match.params;

  const [ email, setEmail ] = useState("");
  const [ error, setError ] = useState("");
  const [ selectValue, setSelectValue ] = useState("-1");

  const [ acceptedPriorities, currentPriorities ] = useState([]);

  const [ result, setResult ] = useState<{ isBooked: boolean, data: any}>({
    isBooked: false,
    data: undefined,
  });

  useEffect(() => {
    getRequest({ url: `public/store/${deviceId}` })
    .then(({ data }: any) => {
      const { priorities } = data;
      currentPriorities(priorities);
    })
    .catch((er) => {
      console.log(er);
    });
  }, []);

  const registerBooking = () => {
    if (+selectValue < 0) {
      setError("Devi scegliere una Priorità");
      return;
    }
    const isValid = validateEmail(email);
    if (!isValid) {
      setError("Invalid Email");
      return;
    }
    postRequest({
      url: `register/${deviceId}`,
      body: {
        email,
        timeOffset: 600000,
        priority: +selectValue,
        bookSource: 1,
      },
    }).then(({ data }: any) => {
      setResult({ isBooked: true, data });
    }).catch((er) => {
      console.log(er);
    });
  };

  return (<div className={style.wrapper} >
    {result.isBooked ?
      (<Confirmation orderNumber={result.data.orderNumber} startDate={result.data.startDate}/>)
      :
      (<div className={style.card}>
        <h1> {translate("booking")} </h1>
        <p className={style.secondarytext}>
          {translate("booking.mail")} <br />
          ({translate("booking.mail-ex")})
        </p>
        <div>
          <TextInput
            type="email"
            label={translate("mail")}
            name="text"
            userName={email}
            updateUserName={setEmail}
          />
        </div>
        <div className={style["input-group"]}>
          <label htmlFor="select"> {translate("priority")}: </label>
          <select
            name="select"
            className={style["select"]}
            value={selectValue}
            onChange={(ev) => setSelectValue(ev.target.value)}
          >
            <option value="-1" disabled={true}> {translate("choose-priority")} </option>
            {allPriorities.filter((e, i) => acceptedPriorities[i]).map((p, i) => {
              return (<option key={i} value={i} > {translate(p)} </option>);
            })}
          </select>
        </div>
        <p style={{ color: "var(--color-danger)", marginTop: 30 }}> {error} </p>
        <div style={{ marginTop: 10, marginBottom: 20 }}>
          <Button
            isActive={true}
            isLoading={true}
            label={translate("confirm.booking")}
            onClick={registerBooking}
          />
        </div>
      </div>)}
  </div>);
};

export default withTitle(translate("booking"))(Register);
